import { AbgSxProps } from '@abg/typings';

export const actionButtonStyle: AbgSxProps = {
  width: {
    md: 'auto',
    xs: '100%',
    sm: 'auto',
  },
};
